const ADULT = 'ADT';
const CHILD = 'CNN';
const INFANT = 'INF';
export default {
  ADULT,
  CHILD,
  INFANT
};